import {
  xlsxCellSerial,
  createXlsxColumn,
  createXlsxCellStyle,
  createColumnWidth,
  createColumnHeight,
  createColumnMerge,
} from "../../../../service/excel";
import moment from "moment";

export const createXlsxDetail = ({
  title,
  data: { workbook, reportType, reportData, optionData },
}) => {
  const ws = workbook.addWorksheet(title);

  let ws_detail = createScope(ws, reportType, reportData, optionData);

  createColumnWidth({
    ws,
    columns: [
      { column: "A", width: 7 },
      { column: "B", width: 22 },
      { column: "C", width: 15 },
      { column: "D", width: 15 },
      { column: "E", width: 15 },
      { column: "F", width: 15 },
      { column: "G", width: 15 },
      { column: "H", width: 15 },
      { column: "I", width: 15 },
      { column: "J", width: 15 },
      { column: "K", width: 15 },
      { column: "L", width: 15 },
      { column: "M", width: 15 },
      { column: "N", width: 15 },
      { column: "O", width: 15 },
      { column: "P", width: 15 },
      { column: "Q", width: 15 },

      { column: "R", width: 15 },
      { column: "S", width: 15 },
      { column: "T", width: 15 },
      ...optionData[`${reportType}_consider`].map((item, index) => ({
        column: xlsxCellSerial[18 + index],
        width: 15,
      })),
      ...optionData[`${reportType}_correct`].map((item, index) => ({
        column:
          xlsxCellSerial[
            18 + optionData[`${reportType}_consider`].length + index
          ],
        width: 15,
      })),
      {
        column:
          xlsxCellSerial[
            18 +
              optionData[`${reportType}_consider`].length +
              optionData[`${reportType}_correct`].length
          ],
        width: 15,
      },
      {
        column:
          xlsxCellSerial[
            18 +
              optionData[`${reportType}_consider`].length +
              optionData[`${reportType}_correct`].length +
              1
          ],
        width: 15,
      },
      {
        column:
          xlsxCellSerial[
            18 +
              optionData[`${reportType}_consider`].length +
              optionData[`${reportType}_correct`].length +
              2
          ],
        width: 15,
      },
      ...optionData[`${reportType}_satisfaction`].map((item, index) => ({
        column:
          xlsxCellSerial[
            18 +
              optionData[`${reportType}_consider`].length +
              optionData[`${reportType}_correct`].length +
              3 +
              index
          ],
        width: 15,
      })),
    ],
  });

  createColumnHeight({
    ws,
    columns: [{ column: 1, height: 24 }],
  });

  createColumnMerge({
    ws,
    columns: [...ws_detail.merges],
  });
};

const createScope = (ws, reportType, reportData, optionData) => {
  let merges = [];
  let head = {
    // 基本資料
    member: [
      { label: "編號", key: "serial" },
      { label: "填答時間", key: "createdatetime" },
      { label: "家長主要信箱", key: "email" },
      { label: "身分", key: "psex" },
      { label: "家長教育程度", key: "edlevel" },
      { label: "小孩性別", key: "ksex" },
      { label: "小孩出生年", key: "birthday" },
      { label: "近視度數(左)", key: "ldegree" },
      { label: "近視度數(右)", key: "rdegree" },
      { label: "散光度數(左)", key: "lastigmatism" },
      { label: "散光度數(右)", key: "rastigmatism" },
      { label: "治療時間", key: "tyear_tmonth" },
      { label: "治療方式", key: "treatment" },
      { label: "眼軸長度(左)", key: "laxis" },
      { label: "眼軸長度(右)", key: "raxis" },
      { label: "是否接受後續問卷調查", key: "isagree" },
      { label: "郵寄地址", key: "address" },
    ],
    // 問卷
    question: [
      { label: "您目前比較想要選擇的方式是", key: "a1" },
      { label: "不進行任何治療，原因", key: "a2" },
      { label: "對於以上治療方式，我想要再瞭解更多", key: "a3" },
      ...optionData[`${reportType}_consider`].map((item, index) => ({
        label: item.label,
        key: `b${index + 1}`,
      })),
      ...optionData[`${reportType}_correct`].map((item, index) => ({
        label: item.label,
        key: `c${index + 1}`,
      })),
      { label: "醫療方式-已經決定", key: "d1" },
      { label: "醫療方式-尚未決定", key: "d2" },
      { label: "醫療方式-尚未決定-其他", key: "d3" },
      ...optionData[`${reportType}_satisfaction`].map((item, index) => ({
        label: item.label,
        key: `e${index + 1}`,
      })),
    ],
  };

  reportData.forEach((rowData, rIdx) => {
    head.member.forEach((member, mIdx) => {
      if (rIdx === 0) {
        createXlsxColumn({
          ws,
          column: `${xlsxCellSerial[mIdx]}1`,
          value: member.label,
          styles: createXlsxCellStyle({
            font_bold: true,
            fill_color: "f2f2f2",
            wrapText: false,
          }),
        });
      }

      let value = rowData.member?.[member.key];
      createXlsxColumn({
        ws,
        column: `${xlsxCellSerial[mIdx]}${2 + rIdx}`,
        value:
          value !== null || value != undefined
            ? member.key === "psex"
              ? optionData.parent_obj[value]?.showLabel
              : member.key === "edlevel"
              ? optionData.education_obj[value]?.showLabel
              : member.key === "ksex"
              ? optionData.sex_obj[value]?.showLabel
              : member.key === "isagree"
              ? optionData.yesno_obj[value]?.showLabel
              : member.key === "birthday"
              ? moment(value).format("YYYY")
              : value
            : "",
        styles: createXlsxCellStyle({
          wrapText: false,
        }),
      });
    });

    head.question.forEach((question, mIdx) => {
      if (rIdx === 0) {
        createXlsxColumn({
          ws,
          column: `${xlsxCellSerial[head.member.length + mIdx]}1`,
          value: question.label,
          styles: createXlsxCellStyle({
            font_bold: true,
            fill_color: "f2f2f2",
            wrapText: false,
          }),
        });
      }

      let value = rowData.question?.[question.key];
      createXlsxColumn({
        ws,
        column: `${xlsxCellSerial[head.member.length + mIdx]}${2 + rIdx}`,
        value: value
          ? question.key === "a1"
            ? value.reduce(
                (pre, cur) =>
                  (pre += `${pre !== "" ? "、" : ""}${
                    optionData[`${reportType}_type_obj`][cur]?.showLabel
                  }`),
                ""
              )
            : [
                "b1",
                "b2",
                "b3",
                "b4",
                "b5",
                "b6",
                "b7",
                "b8",
                "b9",
                "b10",
              ].indexOf(question.key) !== -1
            ? optionData.score_5_obj[value]?.showLabel
            : ["c1", "c2", "c3", "c4", "c5", "c6"].indexOf(question.key) !== -1
            ? optionData.correct_obj[value]?.showLabel
            : question.key === "d1"
            ? value.reduce(
                (pre, cur) =>
                  (pre += `${pre !== "" ? "、" : ""}${
                    optionData[`${reportType}_type_less_obj`][cur]?.showLabel
                  }`),
                ""
              )
            : question.key === "d2"
            ? value.reduce(
                (pre, cur) =>
                  (pre += `${pre !== "" ? "、" : ""}${
                    optionData[`${reportType}_undo_obj`][cur]?.showLabel
                  }`),
                ""
              )
            : ["e1", "e2", "e3", "e4"].indexOf(question.key) !== -1
            ? optionData.yesno_obj[value]?.showLabel
            : value
          : "",
        styles: createXlsxCellStyle({
          wrapText: false,
        }),
      });
    });
  });

  return {
    merges: [...merges],
  };
};
